import { render, staticRenderFns } from "./PhysicalShopsCrud.vue?vue&type=template&id=88ffb648&"
import script from "./PhysicalShopsCrud.vue?vue&type=script&lang=js&"
export * from "./PhysicalShopsCrud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports